<template lang="pug">
	.user-team__skeleton-wrapper
		p.ajax__line.ajax__line-table-text.user-team__skeleton(v-for="col in colCount" :key="col")

</template>

<script>
export default {
  props: {
    colCount: {
      type: Number,
      default: 5
    }
  }
};
</script>
